import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useAuthorizedAxios } from '../../../core/hooks';
import { isValidCustomerId } from '../../../customers';
import { ItsmMaintenanceWorkViewModel, mapItsmMaintenanceWorkApiModelToViewModel } from '../../../itsm/model';
import { getDashboardItsmMaintenanceWorks } from '../../api';
import { DashboardHttpQueryConfig } from '../../config';

export const useDashboardItsmMaintenanceWorks = (customerId: number | null): UseQueryResult<ItsmMaintenanceWorkViewModel[] | null, Error> => {
  const axios = useAuthorizedAxios();
  return useQuery({
    queryKey: [DashboardHttpQueryConfig['GetItsmMaintenanceWorks'].key, customerId],
    queryFn: async () => {
      if (customerId === null) {
        return null;
      } else {
        const maintenanceWorks = await getDashboardItsmMaintenanceWorks(axios, { customerId });
        return maintenanceWorks.map(mapItsmMaintenanceWorkApiModelToViewModel);
      }
    },
    enabled: isValidCustomerId(customerId),
    gcTime: 5000,
    staleTime: 0,
    structuralSharing: false
  });
};